import * as yup from "yup";

const orgFormSchema = yup.object().shape({
    name: yup.string().required("Please specify the organization name"),
    primaryUser: yup.object().shape({
        value: yup.number().required(),
        label: yup.string().required("Please select the primary org. user"),
    }),
    teams: yup
        .array(
            yup.object().shape({
                value: yup.number(),
                label: yup.string(),
            }),
        )
        .optional(),
    approved: yup.boolean().optional(),
});

export default orgFormSchema;
